// eslint-disable-next-line import/prefer-default-export
export const EDITION_FACTURE = {
  title: 'Créer une facture',
  titleFactureAvoir: 'Créer une facture d\'avoir',
  updateTitle: 'Modifier facture n°{code}',
  updateTitleAvoir: 'Modifier facture d\'avoir n°{code}',
  echeancierUpdateTitle: 'Modifier la facture n°{code}',
  problemOccurred: 'Un problème est survenu',
  editSettlement: 'Modifier le mode de règlement',
  modeSettlement: 'Mode de règlement',
  periodSettlement: 'Délai de règlement',
  show: 'Consulter',
  toFinalBillTitle: 'Enregistrement définitif de la facture {code}',
  toFinalBillText: 'Afin de garantir l\'inaltérabilité et la sécurisation de vos données, vous ne pourrez plus modifier cette facture.',
  toDraftBillTitle: 'Passage en brouillon de la facture {code}',
  toDraftBillText: 'Toutes les modifications sur la facture seront de nouveau possible',
  onglet: {
    facture: 'Facture',
    produits: 'Produits',
    echeancier: 'Echéancier de paiement',
    situation: 'Situation',
    previsualisation: 'Paramétrage édition',
    achats: 'Achats',
    info: 'Info générales',
    factor: 'Factor',
  },
  actions: {
    show: 'Consulter',
    revert: 'Annuler',
    save: 'Brouillon',
    addClient: 'Créer un client',
    add: 'Ajouter',
    addLine: 'Ajouter une ligne',
    addSubTotal: 'Ajouter un sous total',
    addComment: 'Ajouter une ligne de texte',
    addFace: 'Face unitaire',
    addRemise: 'Ajouter une remise',
    addNetwork: 'Ajouter un réseau',
    end: 'Terminer',
    addCustomer: 'Ajouter un intervenant',
    toFinalBill: 'Enregistrer définitivement',
    toDraftBill: 'Repasser en brouillon',
    amend: 'Corriger la facture',
  },
  generalTitle: {
    generalInformations: 'Facture',
    ChangeProduits: 'Changement produits',
    generalEcheancier: 'Echéancier de paiement',
  },
  informations: {
    reference: 'Référence',
    agence: 'Agence',
    commercialName: 'Nom commercial',
    postalAddress: 'Adresse postale',
    trade: 'Commercial(e)',
    theme: 'Thème / Objet',
    billDate: 'Date de la facture',
    accountingAccount: 'Compte comptable',
    datePremierAffichage: 'Date de campagne',
    categorieVente: 'Type de produit',
    assistant: 'Assistant(e)',
    customerReference: 'Référence client',
    product: 'Produit',
    regleFacturation: 'Règle de facturation',
    aucunCommercial: 'Aucun(e) commercial(e) sélectionné(e)',
    aucunAssistant: 'Aucun(e) assistant(e) sélectionné(e)',
    rate: 'Tarif',
    wording: 'Libellé',
    quantity: 'Qté',
    unitaryCost: 'P.U.',
    discount: 'Remise',
    percentageTva: '% TVA',
    totalHt: 'Total HT',
    totalHtDiscount: 'Total HT remisé',
    quotationCommentary: 'Commentaires facture',
    internCommentary: 'Commentaires internes',
    adresseLivraison: 'Adresse de livraison',
    totalTtc: 'Total TTC',
    totalTva: 'T.V.A.',
    displayDate: 'Dates d\'affichage',
    from: 'Du',
    to: 'Au',
    occupationPercentage: 'Pourcentage d\'occupation',
    subTotalHt: 'Sous-total HT',
    dontHaveSettlementPeriod: 'Le délai de règlement n\'est pas renseigné',
    dontHaveSettlementMode: 'Le mode de règlement n\'est pas renseigné',
    addText: 'Insérer votre texte',
    penalty: 'En cas de retard de paiement, application d\'intérêts de 3 fois le taux légal selon la loi n°2008-776 du 4 août 2008.',
    penaltyLabel: 'Taux de pénalité',
    recovery: 'En cas de retard de paiement, application d’une indemnité forfaitaire pour frais de recouvrement de 40€ selon l\'article D. 441-5 du code du commerce.',
    recoveryLabel: 'Frais de recouvrement',
    discountRate: 'Pas d’escompte applicable.',
    discountRateLabel: 'Taux d\'escompte',
    settlement: {
      achat: {
        settlementMode: 'Mode de paiement',
        settlementPeriod: 'Délai de paiement',
      },
      vente: {
        settlementMode: 'Mode de règlement',
        settlementPeriod: 'Délai de règlement',
      },
      endMonth: 'Fin de mois le',
      dayNumber: 'Nb de jours',
      dayMonth: 'Jour de facturation',
    },
    folderCode: 'Code dossier',
    commission: 'Commission',
    nePasRelancer: 'Ne pas relancer',
    campagne: 'Campagne',
    tags: 'Tags',
    tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
  },
  table: {
    customer: 'Client',
    settlement: 'Règlement',
    address: 'Adresse commerciale',
    contact: 'Contact',
    tvaIntracommunautaire: 'TVA intracommunautaire',
    percentageOfBilling: 'Quote-part facturation',
    advertiser: 'Annonceur',
    mandatary: 'Mandataire',
    originator: 'Donneur d\'ordre',
    payer: 'Payeur',
    delete: 'Supprimer',
  },
  messages: {
    successCreation: 'Création de la facture réalisée avec succès.',
    successCreationAvoir: 'Création de la facture d\'avoir réalisée avec succès.',
    errorCreation: 'Enregistrement du client impossible. Les champs suivants doivent être renseignés : ',
    editQuotationSuccess: 'Modification de la facture réalisée avec succès.',
    editQuotationSuccessAvoir: 'Modification de la facture d\'avoir réalisée avec succès.',
    successCustomerCreation: 'Création du client réalisé avec succès.',
  },
  clients: {
    searchClient: 'Ajouter un client',
    advertiser: 'Annonceur',
    mandatary: 'Mandataire',
    originator: 'Donneur d\'ordre',
    mandatairePayeur: 'Mandataire payeur',
    mandataireNonPayeur: 'Mandataire non payeur',
    customer: 'Intervenant',
    payer: 'Payeur',
    recipient: 'Destinataire',
    accountingRecipient: 'Destinataire comptable',
    ccRecipient: 'En copie',
    title: 'Titre',
    clientExonerationTva: 'Client exonéré de TVA',
    prospect: 'Prospect',
    annonceurApplicationTva: 'Application TVA de l\'annonceur',
  },
  ligne: {
    singleDay: 'jour',
    multiDays: 'jours',
    dateFrom: 'Du',
    dateTo: 'Au',
    linkCommande: 'Commande n°',
  },
  sousType: {
    normal: 'Facture',
    acompte: 'Acompte',
    avoir: 'Avoir',
  },
  echeancierPaiement: {
    montantTtcZero: 'Impossible d\'accèder à l\'échéancier de paiement tant que le montant de la facture est à 0',
  },
  popUpFactor: {
    title: 'Votre facture a déjà été transmise à votre Factor, voulez vous vraiment changer son factor ?',
  },
  popUpProduct: {
    title: 'Les lignes suivantes n\'ont pas de produit. Etes-vous sûr de vouloir sauvegarder ?',
  },
};

export const VALIDATION = {
  notSameTypeTvaAccount: 'Les produits ne sont pas soumis au même type de compte de tva',
  anneeSemaineRequired: 'Vous devez sélectionner une semaine pour chaque produit réseau',
  destinataire: 'Le destinataire de la facture est obligatoire',
  qteFacesSouhaiteesInf: 'Le nombre de faces souhaitées doit être supérieur à 0.',
  sameProduct: 'Impossible d\'ajouter le même produit à la même date',
  leastOneCustomer: 'Vous devez sélectionner au moins un client par facture.',
  needDiscount: 'Vous devez renseigner la remise',
  normalLine: 'Une ligne de facture est nécessaire entre 2 lignes de remises',
  leastOneAdvertiser: 'Vous devez indiquer au moins un annonceur par facture.',
  leastOnePayer: 'Vous devez indiquer au minimum un payeur par facture.',
  pourcentageDivision: 'La somme des pourcentages de facturation des payeurs doit être égale à 100%.',
  amountDivision: 'La somme des quotes-parts de facturation doit être égale au montant total de la facture.',
  faceDateOverlap: 'Impossible de vendre la même face dans la même commande avec des dates se chevauchant',
  proxyNotRepresentative: 'Un client ne peut être annonceur et mandataire sur une même facture.',
  invoiceCodeMustBeReplacedFully: 'Le code de la facture {param1} n\'a pas pu être généré complètement.',
  unitPriseLessZero: 'Le prix unitaire des produits doit être supérieur à 0.',
  quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
  discountBetween0100: 'La remise de la ligne en pourcentage doit être entre 0 et 100.',
  discountBetween0Amount: 'La remise de la ligne en montant doit être entre 0 et le montant de celle-ci.',
  leastOneProduct: 'Vous devez saisir au minimum un produit dans la facture.',
  notSameDivisionType: 'Les quotes-parts des payeurs doivent être du même type.',
  saveImpossible: 'Enregistrement de la facture impossible.',
  editImpossible: 'Modification de la facture impossible.',
  agenceId: 'Vous devez sélectionner une agence.',
  regulationModeRequired: 'Le mode de règlement est obligatoire.',
  settlementPeriodRequired: 'Le délai de règlement est obligatoire.',
  accountingAccountRequired: 'Le compte comptable du destinataire comptable est obligatoire.',
  paymentDifferent: 'La somme des échéances est différente du montant total de l\'échéancier de paiement',
  ShoudContainsLocationOrBillBoard: 'La vente doit contenir au moins une ligne',
  TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de la vente',
  renouvellableRequiredIfReconductible: 'La reconduction tacite nécessite que la commande soit renouvelable',
  periodeInvalide: 'Une ligne de vente a une période en dehors de la période facturation',
  dateRenouvellementObligatoire: 'La date de renouvellement est obligatoire si la commande est renouvelable.',
  datePreavisObligatoire: 'La date de préavis est obligatoire si la commande est renouvelable.',
  datePreavisForbiddenWithoutRenouvelable: 'La date de préavis ne doit pas être renseignée si la commande n\'est pas renouvelable.',
  noOrderLinkedToBill: 'La facture n\'est pas liée à une commande',
  noOrdersLinkedToBill: 'Une des factures sélectionnées n\'est pas liée à une commande',
  dateRenouvellementForbiddenWithoutRenouvelable: 'La date de renouvellement ne doit pas être renseignée si la commande n\'est pas renouvelable.',
  normalBillAmountPositive: 'Pour une facture, le montant global doit être positif',
  avoirBillAmountNegative: 'Pour un avoir, le montant global doit être négatif',
  googleMapKeyInvalid: 'La clef API google est invalide',
  prospectNotAllowed: 'Impossible d\'enregistrer une facture avec un intervenant prospect',
  remiseInterditeVenteInterne: 'Interdit d\'ajouter une ligne de remise lorsque l\'on vend un produit d\'une autre société',
  remiseInterditeCompta: 'Interdit d\'ajouter une ligne de remise',
  wrongSigneEcheancier: 'Problème de signe sur les échéances',
  titreRecetteEditImpossible: 'Modification du titre de recette impossible.',
  name: {
    libelleLigneCommande: 'Libellé de la ligne',
    quantiteLigneCommande: 'Quantité de la ligne',
    prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
    remiseLigneCommande: 'Remise de la ligne',
    tauxTvaLigneCommande: 'Taux de Tva de la ligne',
    dateDevisCommande: 'La date de la facture',
    dateValidite: 'Date de validité',
    repartitionIntervenant: 'Quote-part facturation',
    tauxPenalite: 'Taux de pénalité',
    tauxEscompte: 'Taux d\'escompte',
    tiersId: 'Le client est obligatoire dans la zone intervenant',
    nombreEcheances: 'Nombre d\'échéances',
    datePremiereEcheance: 'Date de début',
    dateEcheance: 'Date d\'échéance',
    assistant: 'Assistant(e)',
    commercial: 'Commercial(e)',
    codeMandataire: 'Code mandataire du payeur',
    nomDispositif: 'Nom du dispositif',
    montant: 'Montant de l\'échéance',
    materielTypeId: 'Type de matériel',
    dispositifTypeId: 'Type de dispositif',
    materielFormatId: 'Format',
  },
  acompteAmountTooGreat: 'Le montant de l\'acompte est plus grand que le montant du'
    + 'devis ou de la commande',
  acomptePayerIncorrect: 'Le client doit-être aussi un payeur du devis ou de la commande',
  updateSavedAcompte: 'La modification d\'un acompte enregistré est impossible',
  forbiddenAffectedAcompte: 'Impossible de faire un avoir sur un acompte déjà affecté ',
  acompteGreaterThanFacture: 'Impossiblee de créer une facture avec un montant inférieur à l\'acompte',
  annonceurWithSameExonerationTva: 'Tous les annonceurs doivent être éxonérés de TVA',
  annonceurWithSameApplicationTva: 'Tous les annonceurs doivent avoir la même application de TVA',
  factureSavedStateRequired: 'La facture doit être enregistrée',
  hasEntryInsideLot: 'La facture a une écriture associée à un lot',
  paymentPlanShouldNotBeLettered: 'Une échéance de paiement de la facture est lettrée',
  ligneCommandeWithZeroTva: 'Si un annonceur est exonéré de TVA, les lignes de ventes doivent avoir un taux de TVA à 0',
  newCommandeLigneNotAllowedInBillMultiOrder: 'Impossible d\'ajouter de nouvelles lignes de vente dans une facture multi-commandes',
  newIntervenantNotAllowedInBillMultiOrder: 'Impossible d\'ajouter de nouveaux intervenants dans une facture multi-commandes',
  invoiceFinancialCommitmentDateInvalid: 'Le payeur {nomCommercial} étant limité au paiement comptant, la date de la ligne d\'échéance doit être égale à la date de facture',
  invoiceFinancialCommitmentCountInvalid: 'Le payeur {nomCommercial} étant limité au paiement comptant, seule une ligne d\'échéance datée de la date de facture est valide',
  invoiceLockedPayer: 'Le payeur {nomCommercial} est totalement bloqué',
  productPurchase: 'Le produit {libelle} doit avoir un produit opposé de sens achat',
  ligneCommandeWithoutLigneLocation: 'La vente du réseau {reseau} doit avoir une ligne location',
  remiseRegieshouldBeLast: 'La remise régie de la ligne {libelle} du produit {produit} doit être la dernière',
  remiseRegieOnlyOne: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle} du produit {produit}',
  remiseRegieMustBePreceded: 'La remise régie de la ligne {libelle} du produit {produit} doit être précédée d\'une ligne sous total',
  remiseRegieshouldBeLastWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être la dernière',
  remiseRegieOnlyOneWithoutRegroupement: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle}',
  remiseRegieMustBePrecededWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être précédée d\'une ligne sous total',
  regleFacturationRequired: 'La règle de facturation est obligatoire.',
  siretRequired: 'Le champs siret est obligatoire pour les intervenants suivants : {nomCommerciaux}',
  compteComptableRequired: 'Le champs compte comptable est obligatoire pour les intervenants suivants : {nomCommerciaux}',
  modeReglementRequired: 'Le champs mode de règlement est obligatoire pour les intervenants suivants : {nomCommerciaux}',
  delaiReglementRequired: 'Le champs délai de règlement est obligatoire pour les intervenants suivants : {nomCommerciaux}',
  AdresseCodePostalRequired: 'Le champs code postal de l\'adresse est obligatoire pour les intervenants suivants : {nomCommerciaux}',
  tvaIntracommRequired: 'Le champs tva intracommunautaire est obligatoire pour les intervenants suivants : {nomCommerciaux}',
  adresseAdresse1Required: 'Le champs adresse 1 de l\'adresse est obligatoire pour les intervenants suivants : {nomCommerciaux}',
  adressePaysRequired: 'Le champs pays de l\'adresse est obligatoire pour les intervenants suivants : {nomCommerciaux}',
};
export const VALIDATION_AVOIR = {
  anneeSemaineRequired: 'Vous devez sélectionner une semaine pour chaque produit réseau',
  qteFacesSouhaiteesInf: 'Le nombre de faces souhaitées doit être supérieur à 0.',
  sameProduct: 'Impossible d\'ajouter le même produit à la même date',
  leastOneCustomer: 'Vous devez sélectionner au moins un client par avoir.',
  needDiscount: 'Vous devez renseigner la remise',
  normalLine: 'Une ligne d\'avoir est nécessaire entre 2 lignes de remises',
  leastOneAdvertiser: 'Vous devez indiquer au moins un annonceur par avoir.',
  leastOnePayer: 'Vous devez indiquer au minimum un payeur par avoir.',
  faceDateOverlap: 'Impossible de vendre la même face dans la même commande avec des dates se chevauchant',
  proxyNotRepresentative: 'Un client ne peut être annonceur et mandataire sur un même avoir.',
  invoiceCodeMustBeReplacedFully: 'Le code de l\'avoir {param1} n\'a pas pu être généré complètement.',
  discountBetween0100: 'La remise de la ligne en pourcentage doit être entre 0 et 100.',
  discountBetween0Amount: 'La remise de la ligne en montant doit être entre 0 et le montant de celle-ci.',
  leastOneProduct: 'Vous devez saisir au minimum un produit dans la facture.',
  forbiddenAffectedAcompte: 'Impossible de faire un avoir sur un acompte déjà affecté.',
  factureSavedStateRequired: 'Impossible de faire un avoir sur une facture déjà annulée.',
  saveImpossible: 'Enregistrement de l\'avoir impossible.',
  agenceId: 'Vous devez sélectionner une agence.',
  regulationModeRequired: 'Le mode de règlement est obligatoire.',
  settlementPeriodRequired: 'Le délai de règlement est obligatoire.',
  accountingAccountRequired: 'Le compte comptable du destinataire comptable est obligatoire.',
  paymentDifferent: 'La somme des échéances est différente du montant total de l\'échéancier de paiement',
  amountDiffZero: 'Le montant de la facture doit être différent de zéro pour faire un avoir partiel',
  avoirBillAmountNegative: 'Pour un avoir, le montant global doit être négatif',
  wrongSigneEcheancier: 'Problème de signe sur les échéances',
  name: {
    libelleLigneCommande: 'Libellé de la ligne',
    quantiteLigneCommande: 'Quantité de la ligne',
    prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
    remiseLigneCommande: 'Remise de la ligne',
    tauxTvaLigneCommande: 'Taux de Tva de la ligne',
    dateDevisCommande: 'La date de l\'avoir',
    dateValidite: 'Date de validité',
    repartitionIntervenant: 'Quote-part facturation',
    tauxPenalite: 'Taux de pénalité',
    tauxEscompte: 'Taux d\'escompte',
    tiersId: 'Le client est obligatoire dans la zone intervenant',
    nombreEcheances: 'Nombre d\'échéances',
    datePremiereEcheance: 'Date de début',
    dateEcheance: 'Date d\'échéance',
  },
  dateAvoir: 'Date avoir',
  assistant: 'Assistant(e)',
  commercial: 'Commercial(e)',
  editImpossible: 'Modification de la facture d\'avoir impossible.',
  refundGreaterThanFacture: ' Les totaux par TVA de l\'avoir ne doivent pas dépasser ceux de la facture d\'origine',
  positiveNormalCommandLineForbidden: 'Il est interdit d\'avoir une ligne de commande normale positive',
  ligneCommandeWithZeroTva: 'Si un annonceur est exonéré de TVA, les lignes de ventes doivent avoir un taux de TVA à 0',
  paymentPlanShouldNotBeLettered: 'Une échéance de paiement de la facture est lettrée',
};

export const LISTE_FACTURE = {
  title: 'Liste des factures',
  repertoire: 'Commande',
  racine: 'Accueil',
  statusSave: 'Enregistré',
  interne: 'Facture interne',
  factureParEmail: 'Facture par email',
  factureParCourrier: 'Facture par courrier',
  commandesMultiple: 'Multiple',
  generationEcriture: {
    title: 'Générer les écritures comptables',
    success: 'Génération des écritures comptables effectuée avec succès.',
  },
  actions: {
    filtre: 'Filtre',
    newQuotation: 'Nouvelle facture',
    newCreditNote: 'Nouvel avoir',
    drafts: 'Brouillons',
    sent: 'Envoyés',
    accepted: 'Acceptés',
    search: 'Rechercher',
    delete: 'Supprimer',
    save: 'Enregistrer',
    edition: 'Générer édition',
    exportPrelevement: 'Export prélèvement',
    solderManuellement: 'Solder manuellement',
    genererEcriture: 'Générer écritures comptables',
    envoiMailMasse: 'Envoyer par mail',
    titlePreventionSolder: 'Voulez vous solder manuellement les factures sélectionnées ?',
    prelevementXls: 'Export prélèvement excel',
  },
  table: {
    code: 'Facture n°',
    folderCode: 'Code Dossier',
    status: 'Etat',
    date: 'Date',
    type: 'Type',
    amountHt: 'Montant HT',
    amountTtc: 'Montant TTC',
    amountPaid: 'Montant Réglé',
    advertiser: 'Annonceur',
    payer: 'Payeur',
    commercial: 'Commercial(e)',
    datePremierAffichage: 'Date de campagne',
    agence: 'Agence',
    planMedia: 'Plan média',
    regleFacturation: 'Règle fac.',
    categorieVente: 'Categorie vente',
    references: 'N° cmd.',
  },
  type: {
    normal: 'Facture',
    credit: 'Avoir',
    deposit: 'Acompte',
    avoirSurAcompte: 'Avoir sur acompte',
  },
  status: {
    draft: 'Brouillon',
    save: 'Enregistrée',
    cancel: 'Annulée',
    paye: 'Payé',
  },
  error: {
    noActionSelect: 'Aucune action sélectionnée',
    problemInMultiSave: 'La facture suivante n\'a pas pu être enregistrée :',
    editionMultiAgence: 'La génération d\'édition groupée ne peut se faire que sur des factures de la même agence',
    pasDeSolde: 'la facture sélectionnée {code} n\'a pas de montant à solder',
    pasAvoir: 'Action impossible car {qte} éléments sélectionnés sont des avoirs',
    pasEtatAnnule: 'Action impossible car {qte} éléments sélectionnés sont à l\'état "Annulés"',
    pasEtatBrouillon: 'Action impossible car {qte} éléments sélectionnés sont à l\'état "Brouillon"',
    pasFacture: 'Action impossible car {qte} éléments selectionnés ne sont pas des factures',
    pasVentes: 'ActionImpossible car {qte} éléments selectionnés ne concernent pas les ventes',
    exportNoAccountingWriting: 'L\'ecriture comptable de la pièce {code} n\'existe pas',
    exportInvalidAccountingWriting: 'L\'écriture comptable de la facture {code} est invalide',
    problemOccurred: 'Un problème est survenu',
  },
  success: {
    factureSave: '{numberFacture} facture(s) enregistrée(s)',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    planMedia: 'Plan(s) média',
    commande: 'Commande(s)',
    regleFacturation: 'Règle(s) de facturation',
    client: 'Clients',
    type: 'Liste des types',
    etat: 'Liste des états',
    produits: 'Produits',
    parutions: 'Parutions',
    typeProduit: 'Type de produit',
    tiers: 'Client: {client}',
    referenceClient: 'Référence client',
    periode: 'Date de facture',
    au: 'au',
    datePremierAffichage: 'Date de campagne',
    assistant: 'Assistant',
    commercial: 'Commercial',
    agence: 'Agence',
    enseigne: 'Enseigne(s)',
    groupe: 'Groupe(s)',
    noAssistant: 'Sans assistant',
    noCommercial: 'Sans commercial',
    codeDossier: 'Code dossier',
    referencesCommande: 'Commande(s) : {code}',
    modeReglement: 'Mode(s) de règlement',
    theme: 'Thème',
    interne: 'Facture interne',
    nePasRelancer: 'Non relançable',
    factureParEmail: 'Facturer par email',
    montantHt: 'Total HT',
    montantTtc: 'Total TTC',
    error: {
      errorDateFacture: 'La date de fin de la date de facture est supérieure à la date de début',
      errorDatePremierAffichage: 'La date de fin de la date de campagne est supérieure à la date de début',
      errorMontantHt: 'Le minimum du Total HT doit être inférieur au maximum',
      errorMontantTtc: 'Le minimum du Total TTC doit être inférieur au maximum',
    },
    exporteeEnCompta: 'Exportée en compta',
    exporteeEnComptaAnswer: {
      yes: 'Oui',
      no: 'Non',
    },
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    secteur: 'Secteur(s)',
    tags: 'Tags',
  },
  exportExcel: {
    excelGenerateError: 'Impossible d\'exporter le fichier excel si il n\'y a pas de facture',
    excelGenerateSuccess: 'Le fichier excel a été exporté avec succès',
    sheetName: 'Liste factures',
    excelTitle: 'listeFactures.xlsx',
  },
  exportPrelevement: {
    title: 'Export prelevement',
  },
  envoiMailMasse: {
    titre: 'Envoyer par mail',
    steps: {
      selection: {
        titre: 'Choix des destinataires',
        tab: {
          code: 'Code',
          date: 'Date',
          sousType: 'Type',
          payeur: 'Payeur',
          annonceur: 'Annonceur(s)',
          destinataire: 'Destinataire',
        },
      },
      message: {
        titre: 'Ecrire le mail',
        message: 'Message',
      },
    },
    sendMail: 'Envoyer les mails',
    sendingMail: 'Envoi des mails en cours',
    sendedMail: '{send} sur {total} mails envoyés',
    allMailSended: 'Tous les mails ont été envoyés avec succès',
    errorAgence: 'Les agences sélectionnées n\'ont pas le même paramétrage pour le texte de mail pour les factures',
    userEmail: 'L\'utilisateur connecté n\'a pas d\'adresse mail associé',
    errorDestinataire: 'Toutes les factures doivent avoir au moins un destinataire',
    errorCorps: 'Le corps du mail est obligatoire',
    errorPjTooBig: 'Une des pièces jointes est trop grande',
    errorFormatMail: 'Un des destinataire n\'a pas le bon format d\'adresse mail',
    errorDupplicateMail: 'Une facture a une adresse mail en doublons',
    errorAlreadyInCopy: 'Vous êtes déjà en copie de chaque mail, votre adresse ne peut pas être mis en tant que destinaire',
    customSubjectPlaceholder: 'Saisir l\'objet du mail si vous souhaitez le personnaliser. Attention, il sera identique pour tous les emails envoyés',
  },
};

export const SUPPRESSION = {
  irreversible: 'La suppression d\'une facture est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer cette facture ?',
  irreversibleMultiple: 'La suppression des factures est irréversible.',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces factures ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    errorTitle: 'Suppression de la facture impossible.',
    errorTitleMultiple: 'Suppression des factures impossible.',
    error: 'Veuillez réessayer ou contacter le service client.',
    success: 'Suppression de la facture réalisée avec succès.',
    successMultiple: 'Suppression des factures réalisée avec succès.',
  },
  apiMessages: {
    STATE_DRAFT_REQUIRED_TO_DELETE: 'Suppression impossible, la facture {param1} doit être à l\'état Brouillon.',
  },
};

export const ECHEANCIER_PAIEMENT = {
  montantTotal: 'Montant total : ',
  montantTotalPaye: 'Montant payé : ',
  montantResteAPayer: 'Reste à payer : ',
  factureNonRelancable: 'Cette facture ne sera pas prise en compte dans les relances',
  montantPaye: 'Montant TTC payé',
  numero: 'Numéro d\'échéance',
  dateEcheance: 'Date d\'échéance',
  montantTTC: 'Montant TTC de l\'échéance',
  commentaire: 'Commentaire',
  modeReglement: 'Mode de règlement',
  modePaiement: 'Mode de paiement',
  resteAPayer: 'Reste à Payer',
  modifSuccess: 'L’échancier de paiement et la facture ont été modifiés avec succès.',
  informationReglementFacture: {
    title: 'Informations règlement facture',
  },
  informationGeneral: {
    title: 'Informations générales',
    commercial: 'Commercial',
    planMedia: 'Plan Média',
    assistantCommercial: 'Assistant commercial',
    tauxCom: 'Commission',
    theme: 'Thème / Objet',
    aucunCommercial: 'Aucun(e) commercial(e) sélectionné(e)',
    aucunAssistant: 'Aucun(e) assistant(e) sélectionné(e)',
    tags: 'Tags',
    tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
    applicationTva: 'Application TVA de l\'annonceur',
  },
  generation: {
    nbEcheances: 'Nb d\'échéances',
    dateDebut: 'Date de début',
    periodicite: 'Périodicité',
    modeReglement: 'Mode de règlement',
    modePaiement: 'Mode de paiement',
    no: 'Annuler',
    yes: 'Générer',
    irreversible: 'Cela entraînera la suppression des informations préalablement saisies',
    delete: 'L\'échéancier de paiement va être actualisé',
    calerFinDuMois: 'Fin de mois',
  },
  periodicite: {
    semaine: 'semaine',
    mois: 'mois',
    an: 'an',
  },
  childrow: {
    payeLe: 'Payé le',
    montant: 'Montant',
    referenceTire: 'Référence tiré',
    modePaiement: 'Mode de paiement',
    noReglement: 'Aucun règlement reçu ',
    typeDePiece: 'Type de pièce',
    libelle: 'Libellé',
  },
  generer: 'Générer l\'échéancier',
  ajouterEcheance: 'Ajouter une échéance',
  supprimerEcheancier: 'Supprimer l\'échéancier',
  echeancierPaiement: 'Echéancier de paiement',
  cantGenerate: 'Impossible de regénérer l\'échéancier de paiement car une ou plusieurs échéances sont lettrées ou relancées',
  cantDeleteEcheance: 'Impossible de supprimer l\'échéance car elle est relancée',
};
export const DETAIL_FACTURE = {
  typeFacture: 'Facture',
  multiTypeFacture: 'Factures',
  sousTypeAvoir: 'Avoir',
  sousTypeAcompte: 'Acompte',
  popUpMail: {
    title: 'Rédiger votre email',
    inclureFacture: 'Inclure la facture',
    factureObject: 'Facture {code} du {date}',
    contactTitle: 'Contacts facture',
  },
  error: {
    regelementMustBeCancel: 'Vous devez annuler les règlements avant d’annuler votre acompte',
  },
  buttons: {
    solderManuellement: 'Solder manuellement',
    annulerSoldeManuel: 'Annuler le solde manuel',
  },
  popups: {
    confirmationSolderManuellement: 'Voulez-vous solder manuellement cette facture ?',
    confirmationCopieFacture: 'La duplication va vous rediriger vers une page de création de facture pré-remplie avec les informations de la facture n°{code}',
    confirmationAnnulerSoldeManuel: 'Voulez-vous annuler le solde manuel de cette facture ?',
  },
  anchor: {
    title: 'Facture',
    echeancierPaiement: 'Echéancier de paiement',
    comments: 'Commentaires',
    avoirLie: 'Avoir(s) lié(s)',
    piecesJointes: 'Pièces jointes',
  },
  clients: {
    clientExonerationTva: 'Client exonéré de TVA',
    tvaIntra: 'TVA intracommunautaire : {tva}',
    prospect: 'Prospect',
    siretClient: 'Siret : {siret}',
    siretDefault: 'Siret : nc.',
  },
  avoirsLies: {
    title: 'Avoir(s) lié(s)',
    montantTotal: 'Montant total :',
    tab: {
      code: 'Facture n°',
      date: 'Date',
      montant: 'Montant TTC',
      etat: 'Etat',
    },
  },
  ecritureComptable: {
    montantTtcZero: 'Impossible d\'accèder aux écritures comptables car le montant de la facture est à 0',
  },
  messages: {
    info: {
      information: 'Informations',
      factureParMail: '{nom}, souhaite recevoir ses factures par email.',
      instructionsDemat: 'Instructions dématérialisation : {instructions}',
    },
    success: {
      generateEcriture: 'Ecriture mise à jour avec succès',
    },
    error: {
      pasPaye: 'La facture n\'est pas à l\'état payé',
      mvtClientPastTousLettre: 'Toutes les échéances n\'ont pas été payées',
      mvtClientPasLettreAvecMemeOD: 'La facture n\'a pas été soldé manuellement',
    },
  },
  achatVenteInterne: {
    title: 'Factures d\'achat',
    action: {
      generation: 'Re-générer factures d\'achat et de vente interne',
      allGeneration: 'Re-générer toutes les factures d\'achat et de vente interne',
    },
    tab: {
      fournisseur: 'Fournisseur',
      code: 'Facture achat',
      etat: 'Etat',
      montantHt: 'Montant HT',
      referenceFournisseur: 'Facture vente interne',
      status: 'Statut',
    },
    warning: {
      generation: 'Etes-vous sûr de vouloir re-génerer le(s) facture(s) d\'achat et de vente interne ?',
    },
    success: {
      generation: 'Re-génération réalisé avec succès',
    },
    achat: {
      title: 'Détail de la facture d\'achat n°: {code}',
      titleAvoir: 'Détail de l\'avoir d\'achat n°: {code}',
      breadcrumb: {
        title: 'Détail facture achat',
        titleAvoir: 'Détail avoir achat',
      },
      tab: {
        detail: 'Détail',
        ecritureCompta: 'Ecriture comptable',
      },
      steps: {
        infoGenerales: 'Facture',
        echeancier: 'Echéancier de paiement',
        pj: 'Pièces jointes',
        factureVente: 'Facture de vente',
        avoirLie: 'Avoir(s) lié(s)',
      },
      factureVente: {
        title: 'Facture de vente',
        factureVente: 'Facture de vente :',
      },
    },
    vente: {
      title: 'Détail de la facture vente interne n°: {code}',
      titleAvoir: 'Détail de l\'avoir de vente interne n°: {code}',
      breadcrumb: {
        title: 'Détail facture vente interne',
        titleAvoir: 'Détail avoir interne',
        liste: 'Liste des factures',
      },
      tab: {
        detail: 'Détail',
        ecritureCompta: 'Ecriture comptable',
      },
      steps: {
        infoGenerales: 'Facture',
        echeancier: 'Echéancier de paiement',
        pj: 'Pièces jointes',
        factureAchat: 'Facture d\'achat',
        avoirLie: 'Avoir(s) lié(s)',
      },
      factureAchat: {
        title: 'Facture d\'achat',
        factureAchat: 'Facture d\'achat :',
      },
    },
  },
  popUpAvoir: {
    propagationVenteInterne: 'Dans le cas d\'un avoir total, créer aussi les avoirs sur les factures d\'achat et de vente interne liées',
    propagationAvoirPartielVenteInterne: 'Créer aussi les avoirs sur les factures d\'achat et de vente interne liées',
  },
  categorieOperation: 'Catégorie opération : {categorieOperation}',
  categorieOperationDefault: 'nc.',
  commandeVente: 'Commande vente: {code}',
  commentaire: {
    title: 'Commentaire',
    commentaireRelance: 'Commentaire Relance :',
  },
};

export const SELECTION_ECHEANCE = {
  title: 'Détail des mouvements',
  columns: {
    dateEcheance: 'Date échéance',
    libelle: 'Libellé',
    debit: 'Débit',
    credit: 'Crédit',
    resteALettrer: 'Reste à lettrer',
    etat: 'Etat Lettrage',
  },
  errors: {
    problemOccurred: 'Un problème est survenu',
  },
};

export const LIST_FACTURE_COMMISSIONS = {
  actions: {
    annulation: {
      title: 'Voulez-vous annuler la commission ?',
      footer: 'Si la facture est enregistré il y aura un avoir sinon elle sera supprimé',
    },
    facturation: 'Voulez-vous valider la commission ?',
    enregistrement: {
      title: 'Voulez-vous verser la commission ?',
      footer: 'Vous pouvez annuler la commission si besoin',
    },
    masquerCommissionsAnt: 'Masquer les commissions antérieures non validées',
    displayCommissionsAnt: 'Afficher les commissions antérieures non validées ({total})',
  },
  history: {
    title: 'Historique des annulations de la commission',
    table: {
      code: 'Code',
      etat: 'Etat',
      creator: 'Utilisateur',
      montant: 'Montant HT',
      date: 'Date',
    },
  },
  actionsMass: {
    facturation: 'Valider commission',
    enregistrer: 'Verser commission',
    annulation: 'Annuler',
  },
  table: {
    reference: 'Référence',
    commande: 'Commande',
    planMedia: 'Plan média',
    facture: 'Facture',
    remiseBancaire: 'Remise bancaire n°{code}',
    remiseBancaireExterne: 'Remise bancaire',
    referenceEtat: 'Etat',
    dateDevisCommande: 'Date commande',
    listeIntervenants: 'Fournisseur',
    etat: 'Etat commande',
    montantCommission: 'Montant commission',
    typeReferenceExterne: 'Type',
    societe: 'Société',
    avance: 'Avance',
    encaissement: 'Encaissement',
    filtre: {
      au: 'au',
      date: 'Date',
      etat: 'Etat',
      commercial: 'Commercial',
    },
    actions: {
      facturer: 'Valider commission',
      enregistrer: 'Verser commission',
      annuler: 'Annuler',
    },
  },
  ligneCommande: {
    libelle: 'Produit',
    prixUnitaire: 'Prix unitaire',
    quantite: 'Commissions',
    remise: 'Répartition',
    totalHt: 'Total HT',
    totalTtc: 'Total TTC',
    pourcentageTva: 'Taux TVA',
    montantTva: 'Montant TVA',
  },
};

export const FACTOR = {
  titre: 'Factor',
  factor: 'Factor',
  transmis: 'Transmis',
  dateTransmission: 'Date Transmission',
  searchFactor: 'Ajouter un factor',
  commentaire: 'Commentaire factor',
};
